export default class CustomerGroup1ManagementColumnModel {
	static CustomerGroup1ManagementColumn = [
	  {
		  title: 'Customer group 1',
		  align: 'left',
		  field: 'group1Name'
	  },
	  {
		title: 'Price Visible',
		align: 'left',
		field: 'priceVisible',
		lookup: {0: 'No', 1: 'Yes'},		
		}	  
	]
}
